"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const pit_operation_style_1 = __importDefault(require("../pit-operation.style"));
const pit_operation_action_1 = __importDefault(require("../pit-operation.action"));
const custom_grid_1 = __importDefault(require("./custom-grid"));
const pit_operation_column_1 = require("../pit-operation.column");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const authorization_1 = require("utils/authorization");
const modal_1 = require("components/molecules/modal");
const ReportPitOperation = () => {
    const { isError, dataGrid, isLoading, isSuccess, dataStates, errorMessage, documentExport, isLoadingExportPdf, isLoadingExportExcel, } = (0, store_1.useAppSelector)(state => state.report.pitOperation);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Report', 'Pit Operation');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                if (isExternal) {
                    dispatch(pit_operation_action_1.default.getDataGrid(Object.assign(Object.assign({}, dataStates), { contractor_id: userData.contractor_id })));
                }
                else {
                    dispatch(pit_operation_action_1.default.getDataGrid(Object.assign({}, dataStates)));
                }
            }
            if (documentExport.content) {
                // Noob code ↓↓↓↓ maybe change it if found better way
                const a = document.createElement('a'); //Create <a>
                const filetype = documentExport.filetype === 'pdf'
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                a.href = `data:${filetype};base64,` + documentExport.content; //Image Base64 Goes here
                a.download = documentExport.filename; //File name Here
                a.click(); //Downloaded file
                dispatch(pit_operation_action_1.default.clearDocuments());
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, documentExport, fullScreen, isExternal]);
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(pit_operation_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(pit_operation_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(pit_operation_action_1.default.getDataGrid(newDataStates));
    };
    const onSortChange = (e) => {
        dispatch(pit_operation_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        dispatch(pit_operation_action_1.default.getDataGrid(newDataStates));
    };
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'Pit Operation Report', isReportPit: isAuthorized.view, isLoadingExportPdf: isLoadingExportPdf, isLoadingExportExcel: isLoadingExportExcel, onExportToPdf: () => {
                    const payload = Object.assign(Object.assign({}, dataStates), { type: 'pdf' });
                    if (isExternal) {
                        payload.contractor_id = userData.contractor_id;
                    }
                    dispatch(pit_operation_action_1.default.exportDocuments(payload));
                    dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: false, isLoadingExportPdf: true }));
                }, onExportToExcel: () => {
                    const payload = Object.assign(Object.assign({}, dataStates), { type: 'xls' });
                    if (isExternal) {
                        payload.contractor_id = userData.contractor_id;
                    }
                    dispatch(pit_operation_action_1.default.exportDocuments(payload));
                    dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: false, isLoadingExportExcel: true }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(pit_operation_action_1.default.getDataGrid(dataStates));
                    dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => dispatch(pit_operation_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(custom_grid_1.default, { pageable: true, sortable: true, filterable: false, dataGrid: dataGrid, scrollable: 'scrollable', fullScreen: fullScreen, sort: dataStates.sort, dataStates: dataStates, style: pit_operation_style_1.default.gridHeight, onSortChange: onSortChange, onFilterChange: onFilterChange, columns: fullScreen ? pit_operation_column_1.OperatorAttendanceColumnFullWidthProps : pit_operation_column_1.OperatorAttendanceColumnProps, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v) })] }));
};
exports.default = ReportPitOperation;
